const { setUp } = require('./utils/polyfills');
setUp().then(() => {
    // Bookboost: Changed require path from ./web-messenger
    const WebMessenger = require('./bookboost-web-messenger');
    parent.window.__onWebMessengerFrameReady__(WebMessenger);
});
